<template>
  <dl class="clue-dl">
    <dt class="clue-dt">{{label}}<i class="require" v-if="ifRequire"></i></dt>
    <dd class="clue-dd">
      <button :disabled="disabled" class="autopopup-button" @click="openPicker" :style="stylecss" :class="{selected:activeText!=='请选择'}">{{activeText}}</button>
      <button class="iconfont iconyoujiantou" @click="openPicker" v-show="showArrow" :disabled="disabled"></button>
      <mt-date-picker ref="picker" :type="type" v-model="dateValue" year-format="{value} 年" month-format="{value} 月" dateFormat="{value} 日" hourFormat="{value} 时" minuteFormat="{value} 分" class="monthDate" @confirm="affirm" @cancel="cancelDate" :closeOnClickModal="false" :endDate="endDate" :startDate="startDate"
        :class="{hideDay:!showDay,hideMonth:!showMonth}">
      </mt-date-picker>
    </dd>
  </dl>
</template>
<script>
  import {Popup,DatetimePicker} from 'mint-ui';
  import utilTool from '../../assets/js/util.js'
  export default {
    name: "datepopup",
    props: {
      label: {
        type: String,
        default: ''
      },
      endDate: {
        type: Date,
        defaultData: new Date()
      },
      startDate: {
        type: Date,
        defaultData: new Date()
      },
      ifRequire: {
        type: Boolean,
        default: true
      },
      value: {
        //默认值
        type: String,
        default: ''
      },
      showArrow: {
        type: Boolean,
        default: true
      },
      disabled: {
        //是否禁用
        type: Boolean,
        default: false
      },
      stylecss: {
        //输入框样式
        type: Object
      },
      defaultData:{
        type:Date,
        default:function(){
          return new Date()
        }
      },
      showDay: {
        type: Boolean,
        default: true
      },
      showMonth: {
        type: Boolean,
        default: true
      },
      confirm: {
        //输入按键回调
        type: Function
      },
      type: {
        type: String,
        default: 'date'
      },
    },
    watch: {
      value(newValue, oldValue) {
        this.activeText = newValue;
      },
      defaultData(newValue,oldValue){
        this.dateValue=newValue;
      }
    },
    data() {
      return {
        show: false, //显示是否
        activeText: this.value ? this.value : '请选择',
        dateValue:this.defaultData?this.defaultData: new Date()
      };
    },
    methods: {
      openPicker() {
        utilTool.setScrollTop();
        if (!this.showMonth) {
          let days = document.querySelectorAll(".hideDay .picker-slot-center:nth-child(3)");
            [].forEach.call(days, function(div) {
              div.style.display = "none";
            });
            let Months = document.querySelectorAll(".hideDay .picker-slot-center:nth-child(2)");
            [].forEach.call(Months, function(div) {
              div.style.display = "none";
            });
        } else {
          if (!this.showDay) {
            let days = document.querySelectorAll(".hideDay .picker-slot-center:nth-child(3)");
            [].forEach.call(days, function(div) {
              div.style.display = "none";
            });
          }
          let Months = document.querySelectorAll(".hideDay .picker-slot-center:nth-child(2)");
            [].forEach.call(Months, function(div) {
              div.style.display = "block";
            });
        }
        this.dateValue =this.defaultData;
        
        this.$refs.picker.open();
      },
      cancel() {
        utilTool.removeScrollTop();
        this.show = false;
      },
      affirm(value) {
        utilTool.removeScrollTop();
        this.show = false;
        if(this.type=='datetime'){
          this.activeText = this.formatTimeToStr(new Date(value), 'yyyy/MM/dd hh:mm');
        }else{
          if (this.showMonth) {
          if (this.showDay) {
            this.activeText = this.formatTimeToStr(new Date(value), 'yyyy/MM/dd');
          } else {
            this.activeText = this.formatTimeToStr(new Date(value), 'yyyy/MM');
          }
        } else {
          this.activeText = this.formatTimeToStr(new Date(value), 'yyyy');
        }
        }
        this.confirm(value);
      },
      cancelDate() {
        utilTool.removeScrollTop();
      },
    },
    components: {
      mtPopup: Popup,
      mtDatePicker: DatetimePicker
    },
  };
</script>
<style scoped lang="less">
  @color :#509ff7;
  @font:14px;
  .clue-dl{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    padding: .2rem .3rem;
    height: 1rem;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #fff;
    border-top: 1px solid #fff;
    border-right: 1px solid #fff;
    color: #000;
    background: #fff;
    box-sizing: border-box;
    font-size: .28rem;
    .clue-dt{
        min-width: 25%;
        text-align: left;
    }
    .clue-dd{
      display: flex;
    }
  }
  .require {
      position: relative;
      font-style: normal;
      display: inline-block;
  }
  .require::after {
      content: "*";
      width: 10px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      position: absolute;
      top: 50%;
      margin-top: -15px;
      color: red;
      font-style: normal;
  }
  .clue-section .clue-fail-dd {
    border: 1px solid #ea4c3c;
  }
  .clue-section .clue-fail-dd .autopopup-button {
    color: #ea4c3c;
  }
  .clue-section .clue-dt {
    min-width: 25%;
    text-align: left;
  }
  .autopopup {
    display: inline-block;
    vertical-align: middle;
  }
  .iconfontArrow {
    display: inline-block;
    width:50px;
  }
  .autopopup-button {
    display: inline-block;
    width:125px;
    height:49px;
    line-height:49px;
    vertical-align: middle;
    text-align: right;
    position: relative;
    border: none;
    pointer-events: auto;
    user-select: none;
    font-size:14px;
    white-space: nowrap;
    color: #999999;
    background: #fff;
    padding-right:5px;
  }
  .selected {
    color: #000;
  }
  .autopopup-top {
    display: flex;
    height:49px;
    line-height:49px;
    margin: 0 auto;
    justify-content: space-between;
    padding: 0 20px;
    color: @color;
    font-size:16px;
    border-bottom: 1px solid #e5e5e5;
  }
  .autopopup-list {
    width:375px;
  }
  .overlayer {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/datepopup/datepopup.vue